// GDPR cookie-consent store (localStorage-backed, framework-agnostic).
// Categories: necessary (always on), preferences, analytics, marketing.
const KEY = "vs_cookie_consent_v1";
const VERSION = 1;
const listeners = new Set();

const BASE = { necessary: true, preferences: false, analytics: false, marketing: false };

function read() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const p = JSON.parse(raw);
    if (!p || typeof p !== "object" || !p.categories) return null;
    return p;
  } catch {
    return null;
  }
}

export function hasDecision() {
  return !!read();
}

export function getConsent() {
  const stored = read();
  if (stored?.categories) return { ...BASE, ...stored.categories, necessary: true };
  return { ...BASE };
}

export function hasConsent(category) {
  return !!getConsent()[category];
}

export function setConsent(categories) {
  const payload = {
    version: VERSION,
    ts: new Date().toISOString(),
    categories: {
      necessary: true,
      preferences: !!categories.preferences,
      analytics: !!categories.analytics,
      marketing: !!categories.marketing,
    },
  };
  try {
    localStorage.setItem(KEY, JSON.stringify(payload));
  } catch {
    /* ignore storage errors */
  }
  emit();
  return payload;
}

export function acceptAll() {
  return setConsent({ preferences: true, analytics: true, marketing: true });
}

export function rejectAll() {
  return setConsent({ preferences: false, analytics: false, marketing: false });
}

export function subscribe(cb) {
  listeners.add(cb);
  return () => listeners.delete(cb);
}

function emit() {
  const state = getConsent();
  listeners.forEach((cb) => {
    try {
      cb(state);
    } catch {
      /* ignore listener errors */
    }
  });
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent("vs-consent-change", { detail: state }));
  }
}

// Lets any component (e.g. a "Cookie preferences" link) reopen the settings dialog.
export function openPreferences() {
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent("vs-open-cookie-preferences"));
  }
}
